module.exports = __webpack_public_path__ + "img/upload_data.6d72fa9f.svg";